import { ArrowLeft } from "lucide-react"
import { Button } from "./ui/button"
import { useNavigate } from "react-router-dom"

export default function CustomerDetailHeader() {
  const navigate = useNavigate()
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button
        variant="outline"
        size="sm"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="size-4" />
        Back
      </Button>
      <div>
        <h1 className="text-3xl font-bold">Customer Details</h1>
        <p className="text-muted-foreground">
          Manage customer information and monitor their devices
        </p>
      </div>
    </div>
  )
}
